import InsightsTemplate from './Page';
export default InsightsTemplate;
